import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IMessageResponse } from '_core/types';
import { ValidateBigDataQuestionTypes } from '../Types';

const machine = Machines.onValidateBigDataQuestion.machine;

export const validateBigDataQuestion = (
  params: ValidateBigDataQuestionTypes.ValidateBigDataQuestionServiceRequestType,
): Promise<IMessageResponse> => {
  return callServiceMachine(machine, params);
};

export default { validateBigDataQuestion };
